import React from 'react';
import Seo from '../components/Seo';
import SectionContact from '../components/SectionContact';
import Bande from '../components/Bande';
import Reveal from '../components/Reveal';
import TitreSection from '../components/TitreSection';
import AppelAction from '../components/AppelAction';
import Chiffres from '../components/Chiffres';
import Avis from '../components/Avis';
import { ENTREPRISE } from '../data/site';

export default function Entreprise() {
  return (
    <>
      <Seo
        titre="BATI SELECT TP, loueur d'engins à Alfortville (94)"
        description="BATI SELECT TP loue des engins de chantier aux professionnels du BTP et de l'industrie depuis Alfortville. Parc récent, machines assurées, livraison en Île-de-France."
      />

      <section className="bg-nuit text-white relative overflow-hidden">
        <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
        <div className="conteneur relative py-14 sm:py-16">
          <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
            <div>
              <h1 className="font-display uppercase text-[36px] sm:text-[48px] leading-[1]">
                Un loueur à taille <span className="mot-degrade">humaine</span>
              </h1>
              <p className="mt-5 text-white/75 max-w-xl text-[18px]">
                BATI SELECT TP est basée au 2 boulevard Carnot à Alfortville, au cœur du
                Val-de-Marne. Neuf personnes qui font ce métier depuis des années,
                dix-huit machines, au service des professionnels du bâtiment, des travaux
                publics et de l'industrie, dans toute l'Île-de-France.
              </p>
            </div>
            <div className="relative">
              <div className="absolute -inset-x-3 -bottom-2 h-2 bande-chantier" aria-hidden="true" />
              <img
                src="/images/ecr25d-contrejour.jpg"
                alt="Mini-pelle Volvo ECR25D de BATI SELECT TP prête au départ"
                className="photo-entiere relative rounded-[4px] shadow-haut max-h-[420px] w-auto mx-auto"
              />
            </div>
          </div>
        </div>
        <Bande hauteur={6} />
      </section>

      <section className="bg-white py-14 sm:py-16">
        <div className="conteneur">
          <TitreSection avant="Trois principes, tenus au " mot="quotidien" />
          <div className="mt-9 grid gap-6 md:grid-cols-3">
            {[
              {
                t: 'On répond vite',
                p: "Une demande de devis reçue le matin part dans la journée. Un pro qui attend trois jours une réponse a déjà appelé quelqu'un d'autre, et il a raison.",
              },
              {
                t: 'On dit ce qui est',
                p: "Si la machine ne passe pas chez vous, on vous le dit. Si elle n'est pas disponible à vos dates, on vous le dit aussi. On préfère perdre une location que perdre un client.",
              },
              {
                t: 'On reste joignable',
                p: "Pas de plateforme, pas de numéro de dossier. Vous appelez le 06 01 24 47 24 et vous parlez à l'un des neuf membres de l'équipe, qui connaît les machines et votre chantier.",
              },
            ].map((b, i) => (
              <Reveal key={b.t} delai={i * 0.08}>
                <div className="h-full carte p-7 border-t-4 border-t-jaune">
                  <h3 className="font-cond uppercase font-bold tracking-[0.03em] text-[20px] text-nuit">{b.t}</h3>
                  <p className="mt-3 text-nuit/75">{b.p}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Chiffres />

      <section className="bg-white py-14 sm:py-16">
        <div className="conteneur grid lg:grid-cols-[1fr_0.85fr] gap-10 lg:gap-14 items-center">
          <div>
            <TitreSection avant="Des machines récentes, et " mot="entretenues" />
            <p className="mt-5 text-nuit/85 text-[17px]">
              Dix-huit machines au parc. Nos mini-pelles sont des Volvo à rayon court et une
              Sunward de 2025 à rayon ultra-court, notre chariot télescopique un JCB 525-60
              de 2025. Toutes sont révisées entre chaque location et repartent avec leurs
              documents de conformité.
            </p>
            <p className="mt-4 text-nuit/85 text-[17px]">
              Nous complétons avec les équipements qui font gagner du temps sur un chantier :
              brise-roche hydraulique, pince de tri, godets de terrassement et de curage.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              ['/images/jcb525-profil.jpg', 'Chariot télescopique JCB 525-60'],
              ['/images/swe25uf-remorque.jpg', 'Mini-pelle Sunward SWE25UF'],
              ['/images/ecr50d-arriere.jpg', 'Mini-pelle Volvo ECR50D'],
              ['/images/acc-godets.jpg', 'Godets de terrassement'],
            ].map(([src, alt]) => (
              <figure key={src} className="bg-trame border border-nuit/10 p-2.5 flex items-center justify-center">
                <img src={src} alt={alt} loading="lazy" className="photo-entiere max-h-[210px] w-auto" />
              </figure>
            ))}
          </div>
        </div>
      </section>

      <AppelAction titre="Envie de voir les machines ?" texte={`Le dépôt est au ${ENTREPRISE.adresse}, ${ENTREPRISE.codePostal} ${ENTREPRISE.ville}. Appelez avant de passer, on vous accueille du lundi au vendredi de 8h à 17h.`} />

      <Avis />
      <SectionContact
        avant="Un chantier, une question, une "
        mot="visite ?"
        intro="Écrivez-nous ou passez nous voir au dépôt. On répond en quelques heures, du lundi au vendredi de 8h à 17h."
      />
    </>
  );
}
